import request from '@/utils/request'

// 查询列表
export function apiScpMrpBomStructuresList (query) {
  return request({
    url: '/scp/scpMrpBomStructures/list',
    method: 'get',
    params: query
  })
}
